/** Event gallery images — mirrors website/events.php glob of images/events/event (*).jpg */

export const EVENT_PHOTOS = Array.from({ length: 59 }, (_, i) => {
  const name = `event (${i + 1}).jpg`;
  return {
    src: `/images/events/${name}`,
    alt: `Event at Nouakchott Oumtounsy International Airport (NKC/GQNO) — photo ${i + 1}`,
  };
});
